import { render } from "./FixedCalendar.vue?vue&type=template&id=356e094d&scoped=true"
import script from "./FixedCalendar.vue?vue&type=script&lang=js"
export * from "./FixedCalendar.vue?vue&type=script&lang=js"

import "./FixedCalendar.vue?vue&type=style&index=0&id=356e094d&lang=scss&scoped=true"

import exportComponent from "/home/douglas/Documents/Rwi/surefooted-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-356e094d"]])

export default __exports__